import { Col, ListGroup, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "./Dashboard.css";
import api from "common/api";
import Spinner from "../../spinner";

function CourseList() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/courses/`);
        setCourses(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <p>
        <Row className="mt-4">
          <Col lg={6}>
            <h4 className="mb-4">Aktivne grupe</h4>
            <ListGroup variant="flush">
              {courses.map((course: any) => (
                <Link to={`/grupa/${course.id}`}>
                  <ListGroup.Item className="active-education-card d-flex align-items-center justify-content-between">
                    {course.title}
                  </ListGroup.Item>
                </Link>
              ))}
            </ListGroup>
          </Col>
        </Row>
      </p>
    </>
  );
}

export default CourseList;
